import { render, staticRenderFns } from "./UnsavedModalPlugin.vue?vue&type=template&id=6c834176&scoped=true"
import script from "./UnsavedModalPlugin.vue?vue&type=script&lang=js"
export * from "./UnsavedModalPlugin.vue?vue&type=script&lang=js"
import style0 from "./UnsavedModalPlugin.vue?vue&type=style&index=0&id=6c834176&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c834176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c834176')) {
      api.createRecord('6c834176', component.options)
    } else {
      api.reload('6c834176', component.options)
    }
    module.hot.accept("./UnsavedModalPlugin.vue?vue&type=template&id=6c834176&scoped=true", function () {
      api.rerender('6c834176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/UnsavedChangesModalPlugin/UnsavedModalPlugin.vue"
export default component.exports